module.exports = __webpack_public_path__ + "img/blank-Avatar.dc8b1732.png";